import React from 'react';
import {Element,NameElement,DateElement,CompanyElement,JobTitleElement,IconElement} from './elements.js';

/*---------------------------------------------*/

export default class Details extends Element {
	render() {
		let elements = (this.props.elements || 'name,job_title,date').split(',');
		let data = this.props.data;

		let lineHeight = 1.5;
		let display = this.props.inline ? 'inline' : 'inline-block';
		let styles =  {
			name: {
				fontSize: 18,
				fontWeight: 'bold',
				lineHeight: lineHeight
			},
			jobTitle: {
				display: display,
				fontSize: 16,
				lineHeight: lineHeight
			},
			company: {
				display: display,
				fontSize: 16,
				lineHeight: lineHeight,
			},
			date: {
				display: display,
				fontSize: 16,
				lineHeight: lineHeight
			},
			icon: {
				display: display,
				fontSize: 16,
				lineHeight: lineHeight
			},
			line: {
				fontSize: 0, // prevent from empty lines of details taking up any space
				display: this.props.inline ? 'inline-block' : 'block',
				verticalAlign: this.props.inline ? '' : 'bottom'
			}
		}

		let alignment = this.props.alignment || this.context.get('template.alignment','left');
		let dateElement = <DateElement date={data.date} link={data.source_link || data.link} baseStyle={styles.date} key="date" />;
		let iconElement = <IconElement type={data.source} link={data.source_link || data.link} baseStyle={styles.icon} key="icon" />;
		let dateAndIcon = (alignment === 'right') ? [iconElement,dateElement] : [dateElement,iconElement];

		if (alignment === 'right') {
			styles.company.marginLeft = 6;
		} else {
			styles.jobTitle.marginRight = 6;
		}
		if (this.props.inline) {
			if (alignment === 'left')
				styles.line.marginRight = 4;
			else
				styles.line.marginLeft = 4;
		}
		
		let nameComponent = <NameElement name={data.author_name} baseStyle={styles.name} key="name" />;
		let components = {
			name: (
				<div style={styles.line} key="name">
					{nameComponent}
				</div>
			),
			job_title: (this.context.get('fields.job_title.enabled') || this.context.get('fields.company.enabled')) && (
				<div className="trim-spaces" style={styles.line} key="job">
					<JobTitleElement title={data.job_title} baseStyle={styles.jobTitle} />
					<CompanyElement url={data.company_url} text={data.company_name} baseStyle={styles.company} />
				</div>
			),
			date: (this.context.get('fields.date.enabled') || this.context.get('fields.icon.enabled')) && (
				<div className="trim-spaces" style={styles.line} key="date-icon">
					{dateAndIcon}
				</div>
			)
		};

		return elements.map((element) => components[element]);
	}
}

/*---------------------------------------------*/
